import { render, staticRenderFns } from "./OrderHome.vue?vue&type=template&id=4574a223&scoped=true"
import script from "./OrderHome.vue?vue&type=script&lang=js"
export * from "./OrderHome.vue?vue&type=script&lang=js"
import style0 from "./OrderHome.vue?vue&type=style&index=0&id=4574a223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4574a223",
  null
  
)

export default component.exports